// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2XzC7","title":"card_title__2abzT","inActive":"card_inActive__1RN9H"};